import { Target, Shuffle, FlaskConical, BarChart3, Calculator, Crosshair, Timer } from "lucide-react";

export const MODE_META = {
  topic: { icon: Target, desc: "Pick an AAMC topic or subtopic and drill original passages on it." },
  mixed: { icon: Shuffle, desc: "Passages from several different topics across this section." },
  experimental: { icon: FlaskConical, desc: "Research design, variables, figures and scientific conclusions." },
  graph: { icon: BarChart3, desc: "Every passage has a quantitative graph or table to interpret." },
  calculation: { icon: Calculator, desc: "MCAT equations, mathematical relationships and units." },
  weakness: { icon: Crosshair, desc: "Rebuilds your weakest learning objectives, topics and reasoning skills from your error history." },
  timed: { icon: Timer, desc: "Set a timer and work in exam-style navigation with flagging." },
};

export const SKILL_LABELS = {
  knowledge_application: "Knowledge application",
  experimental_reasoning: "Experimental reasoning",
  data_interpretation: "Data interpretation",
  scientific_prediction: "Scientific prediction",
  mathematical_reasoning: "Mathematical reasoning",
  research_evaluation: "Research evaluation",
};

export const SECTION_ACCENT = { cp: "#e08a2a", cars: "#8b5cf6", bb: "#2A5CE0", ps: "#3BB6D9" };

export const LETTERS = ["A", "B", "C", "D"];

export function scaledScore(correct, total) {
  if (!total) return 118;
  const pct = correct / total;
  const curve = [[0, 118], [0.25, 118], [0.4, 121], [0.5, 123], [0.6, 125], [0.7, 127], [0.8, 129], [0.9, 131], [0.97, 132], [1, 132]];
  for (let i = 1; i < curve.length; i += 1) {
    const [x0, y0] = curve[i - 1];
    const [x1, y1] = curve[i];
    if (pct <= x1) return Math.round(y0 + (y1 - y0) * (x1 > x0 ? (pct - x0) / (x1 - x0) : 0));
  }
  return 132;
}
